const PREFIX = 'CAMPAIGNS';

export const LIST_CAMPAIGNS = `${PREFIX}/LIST`;
export const RETRIEVE_CAMPAIGN = `${PREFIX}/RETRIEVE`;
export const CREATE_CAMPAIGN = `${PREFIX}/CREATE`;
export const UPDATE_CAMPAIGN = `${PREFIX}/UPDATE`;
export const SET_FILTER_CAMPAIGN = `${PREFIX}/SET_FILTER`;
